var _clipPath;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteSq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3000px",
    height: "2000px",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-28363,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard11",
    transform: "matrix(1,0,0,1,-0.333333,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28363.3,
    y: 0,
    width: 3000,
    height: 2000,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28363.3,
    y: 0,
    width: 3000,
    height: 2000
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.64032,0,0,3.09355,28363.3,-4.54747e-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 646.506,
    height: 646.506,
    style: {
      fill: "rgb(248,241,231)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.37826,0,0,3.04378,29317.5,-4069.56)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 673.532,
    y: 1818.11,
    width: 97.403,
    height: 60.795,
    style: {
      fill: "rgb(252,201,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.37826,0,0,3.04378,29317.5,-4069.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M771.969,1818.11c0,-0.258 -0.463,-0.468 -1.034,-0.468l-97.403,-0c-0.571,-0 -1.034,0.21 -1.034,0.468l0,60.795c0,0.259 0.463,0.469 1.034,0.469l97.403,-0c0.571,-0 1.034,-0.21 1.034,-0.469l0,-60.795Zm-2.068,0.469l-0,59.858c-0,0 -95.334,0 -95.334,0c-0,0 -0,-59.858 -0,-59.858l95.334,-0Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.57239,8.86843e-14,0,2.60236,28556.6,-3240.16)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 673.312,
    y: 1850.07,
    width: 18.917,
    height: 28.836,
    style: {
      fill: "rgb(134,229,253)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.57239,8.86843e-14,0,2.60236,28556.6,-3240.16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M692.783,1850.07c0,-0.302 -0.248,-0.547 -0.554,-0.547l-18.917,-0c-0.306,-0 -0.554,0.245 -0.554,0.547l0,28.836c0,0.303 0.248,0.548 0.554,0.548l18.917,0c0.306,0 0.554,-0.245 0.554,-0.548l0,-28.836Zm-1.108,0.548l0,27.741c0,-0 -17.809,-0 -17.809,-0c0,-0 0,-27.741 0,-27.741l17.809,0Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M702.294,1828.31c0.139,-0 0.267,-0.073 0.338,-0.193c0.071,-0.12 0.073,-0.268 0.005,-0.39l-18.495,-33.482c-0.069,-0.125 -0.201,-0.203 -0.344,-0.203c-0.143,0 -0.275,0.078 -0.344,0.203c0,0 -18.495,33.482 -18.495,33.482c-0.068,0.122 -0.065,0.27 0.005,0.39c0.071,0.12 0.199,0.193 0.338,0.193l36.992,-0Zm-0.666,-0.786l-35.66,0c0,0 17.83,-32.276 17.83,-32.276l17.83,32.276Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M702.294,1827.91l-36.992,0l18.496,-33.482l18.496,33.482Z",
    style: {
      fill: "rgb(245,209,187)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M702.294,1828.31c0.139,-0 0.267,-0.073 0.338,-0.193c0.071,-0.12 0.073,-0.268 0.005,-0.39l-18.495,-33.482c-0.069,-0.125 -0.201,-0.203 -0.344,-0.203c-0.143,0 -0.275,0.078 -0.344,0.203c0,0 -18.495,33.482 -18.495,33.482c-0.068,0.122 -0.065,0.27 0.005,0.39c0.071,0.12 0.199,0.193 0.338,0.193c0,-0 36.992,-0 36.992,-0Zm-0.666,-0.786l-35.66,0c0,0 17.83,-32.276 17.83,-32.276l17.83,32.276Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27965.6,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M747.646,1827.91l-82.344,0l-18.495,-33.482l82.343,0l18.496,33.482Z",
    style: {
      fill: "rgb(225,172,137)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27965.6,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M747.646,1828.31c0.139,-0 0.268,-0.073 0.338,-0.193c0.071,-0.12 0.073,-0.268 0.006,-0.39l-18.496,-33.482c-0.069,-0.125 -0.201,-0.203 -0.344,-0.203l-82.343,0c-0.139,0 -0.268,0.074 -0.338,0.194c-0.071,0.119 -0.073,0.268 -0.006,0.389l18.496,33.482c0.069,0.125 0.2,0.203 0.343,0.203l82.344,-0Zm-0.666,-0.786l-81.446,0c0,0 -18.061,-32.696 -18.061,-32.696c-0,0 81.446,0 81.446,0l18.061,32.696Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 375.818,
    y: 1837.29,
    width: 70.918,
    height: 41.615,
    style: {
      fill: "rgb(245,209,187)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M447.129,1837.29c-0,-0.217 -0.176,-0.393 -0.393,-0.393l-70.918,0c-0.217,0 -0.393,0.176 -0.393,0.393l0,41.615c0,0.217 0.176,0.393 0.393,0.393l70.918,0c0.217,0 0.393,-0.176 0.393,-0.393l-0,-41.615Zm-0.786,0.393l0,40.83c0,-0 -70.132,-0 -70.132,-0c-0,-0 -0,-40.83 -0,-40.83l70.132,-0Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.6862,0,0,1.39306,26549.4,-967.997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M686.136,1878.9l-206.658,0c0,0 0,0.001 0,0.001c3.151,27.381 9.895,44.863 17.306,44.863l174.154,-0c6.906,-0 13.034,-18.087 15.198,-44.86c-0,-0.003 -0,-0.004 -0,-0.004Z",
    style: {
      fill: "rgb(230,230,230)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(26.2924,0,0,3.62915,19049.9,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.818,1879.3l70.918,0c0.03,0 0.054,-0.176 0.054,-0.393c0,-0.216 -0.024,-0.392 -0.054,-0.392l-70.918,-0c-0.03,-0 -0.054,0.176 -0.054,0.392c-0,0.217 0.024,0.393 0.054,0.393Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.00593,0,0,3.00593,28079.3,-4149.46)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 375.818,
    y: 1837.29,
    width: 70.918,
    height: 41.615,
    style: {
      fill: "rgb(245,209,187)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.00593,0,0,3.00593,28079.3,-4149.46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M447.21,1837.29c0,-0.262 -0.212,-0.474 -0.474,-0.474l-70.918,-0c-0.262,-0 -0.474,0.212 -0.474,0.474l-0,41.615c-0,0.262 0.212,0.475 0.474,0.475l70.918,-0c0.262,-0 0.474,-0.213 0.474,-0.475l0,-41.615Zm-0.948,0.474l-0,40.667c-0,0 -69.97,0 -69.97,0c0,0 0,-40.667 0,-40.667l69.97,0Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.104,0,0,2.104,28436.5,-2579.91)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 375.818,
    y: 1837.29,
    width: 70.918,
    height: 41.615,
    style: {
      fill: "rgb(245,209,187)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.104,0,0,2.104,28436.5,-2579.91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M447.413,1837.29c0,-0.374 -0.303,-0.677 -0.677,-0.677l-70.918,-0c-0.374,-0 -0.678,0.303 -0.678,0.677l0,41.615c0,0.375 0.304,0.678 0.678,0.678l70.918,-0c0.374,-0 0.677,-0.303 0.677,-0.678l0,-41.615Zm-1.355,0.678l0,40.26c0,-0 -69.563,-0 -69.563,-0c0,-0 0,-40.26 0,-40.26l69.563,-0Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.55572,0,0,3.62915,29779.9,-5169.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 375.818,
    y: 1837.29,
    width: 70.918,
    height: 41.615,
    style: {
      fill: "rgb(225,172,137)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.55572,0,0,3.62915,29779.9,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.736,1836.9c0.506,0 0.916,0.176 0.916,0.393l0,41.615c0,0.217 -0.41,0.393 -0.916,0.393l-70.918,0c-0.506,0 -0.916,-0.176 -0.916,-0.393l-0,-41.615c-0,-0.217 0.41,-0.393 0.916,-0.393l70.918,0Zm-0.916,0.786l-69.086,-0c0,-0 0,40.83 0,40.83c0,-0 69.086,-0 69.086,-0l-0,-40.83Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.28856,0,0,3.00593,29693.2,-4149.46)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 375.818,
    y: 1837.29,
    width: 70.918,
    height: 41.615,
    style: {
      fill: "rgb(225,172,137)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.28856,0,0,3.00593,29693.2,-4149.46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.736,1836.82c0.611,-0 1.106,0.212 1.106,0.474l0,41.615c0,0.262 -0.495,0.475 -1.106,0.475l-70.918,-0c-0.611,-0 -1.106,-0.213 -1.106,-0.475l-0,-41.615c-0,-0.262 0.495,-0.474 1.106,-0.474c-0,-0 70.918,-0 70.918,-0Zm-1.106,0.948l-68.706,0c0,0 0,40.667 0,40.667c0,0 68.706,0 68.706,0l-0,-40.667Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.90193,0,0,2.104,29566.2,-2579.91)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 375.818,
    y: 1837.29,
    width: 70.918,
    height: 41.615,
    style: {
      fill: "rgb(225,172,137)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.90193,0,0,2.104,29566.2,-2579.91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.736,1836.61c0.873,-0 1.58,0.303 1.58,0.677l0,41.615c0,0.375 -0.707,0.678 -1.58,0.678l-70.918,-0c-0.873,-0 -1.581,-0.303 -1.581,-0.678l0,-41.615c0,-0.374 0.708,-0.677 1.581,-0.677c-0,-0 70.918,-0 70.918,-0Zm-1.581,1.355l-67.757,-0c0,-0 0,40.26 0,40.26c0,-0 67.757,-0 67.757,-0l0,-40.26Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.564,1837.29l-0,20.808l3.124,-3.124l1.672,1.673l2.421,-2.421l2.751,2.751l-0,-19.687l-9.968,0Z",
    style: {
      fill: "rgb(254,255,254)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.564,1836.9c-0.217,0 -0.393,0.176 -0.393,0.393l0,20.808c0,0.159 0.096,0.302 0.243,0.363c0.146,0.06 0.315,0.027 0.428,-0.085l2.846,-2.846c-0,-0 1.395,1.395 1.395,1.395c0.153,0.153 0.402,0.153 0.555,-0l2.143,-2.143c0,-0 2.473,2.473 2.473,2.473c0.112,0.112 0.281,0.146 0.428,0.085c0.147,-0.061 0.243,-0.204 0.243,-0.363l-0,-19.687c-0,-0.217 -0.176,-0.393 -0.393,-0.393l-9.968,0Zm0.393,0.786l9.182,-0c0,-0 0,18.346 0,18.346c0,-0 -2.08,-2.08 -2.08,-2.08c-0.153,-0.154 -0.402,-0.154 -0.556,-0l-2.143,2.143c0,-0 -1.395,-1.396 -1.395,-1.396c-0.153,-0.153 -0.402,-0.153 -0.555,0l-2.453,2.454l-0,-19.467Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.00593,0,0,3.00593,28079.3,-4149.46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.564,1837.29l-0,20.808l3.124,-3.124l1.672,1.673l2.421,-2.421l2.751,2.751l-0,-19.687l-9.968,0Z",
    style: {
      fill: "rgb(254,255,254)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.00593,0,0,3.00593,28079.3,-4149.46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.564,1836.82c-0.262,-0 -0.474,0.212 -0.474,0.474l-0,20.808c-0,0.192 0.115,0.364 0.293,0.438c0.177,0.073 0.381,0.033 0.516,-0.103l2.789,-2.788c-0,-0 1.337,1.337 1.337,1.337c0.185,0.186 0.486,0.186 0.671,0l2.085,-2.085c0,0 2.416,2.415 2.416,2.415c0.135,0.136 0.339,0.177 0.516,0.103c0.177,-0.073 0.293,-0.246 0.293,-0.438l0,-19.687c0,-0.262 -0.212,-0.474 -0.474,-0.474c-0,-0 -9.968,-0 -9.968,-0Zm0.474,0.948l9.02,0c-0,0 -0,18.068 -0,18.068c-0,0 -1.942,-1.941 -1.942,-1.941c-0.185,-0.185 -0.485,-0.185 -0.67,0l-2.086,2.085c0,0 -1.337,-1.337 -1.337,-1.337c-0.185,-0.185 -0.486,-0.185 -0.671,-0l-2.314,2.314l0,-19.189Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.104,0,0,2.104,28436.5,-2579.91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.564,1837.29l-0,20.808l3.124,-3.124l1.672,1.673l2.421,-2.421l2.751,2.751l-0,-19.687l-9.968,0Z",
    style: {
      fill: "rgb(254,255,254)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.104,0,0,2.104,28436.5,-2579.91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.564,1836.61c-0.374,-0 -0.677,0.303 -0.677,0.677l-0,20.808c-0,0.274 0.165,0.521 0.418,0.626c0.253,0.105 0.544,0.047 0.738,-0.147l2.645,-2.645c-0,0 1.193,1.194 1.193,1.194c0.265,0.265 0.694,0.265 0.959,0l1.941,-1.941c0,-0 2.272,2.271 2.272,2.271c0.194,0.194 0.485,0.252 0.738,0.147c0.253,-0.105 0.418,-0.352 0.418,-0.626l0,-19.687c0,-0.374 -0.303,-0.677 -0.677,-0.677c-0,-0 -9.968,-0 -9.968,-0Zm0.677,1.355l8.613,-0c0,-0 0,17.373 0,17.373c0,0.001 -1.594,-1.594 -1.594,-1.594c-0.264,-0.264 -0.693,-0.264 -0.958,0l-1.942,1.942c0,-0 -1.193,-1.194 -1.193,-1.194c-0.265,-0.264 -0.694,-0.264 -0.958,0l-1.968,1.967l0,-18.494Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M531.068,1854.89c0,0 15.962,8.96 28.384,15.933c1.712,0.96 2.56,2.955 2.063,4.854c-0.496,1.9 -2.212,3.224 -4.175,3.224c-16.296,0 -40.117,0 -49.639,0c-1.103,0 -2.161,-0.438 -2.941,-1.218c-0.78,-0.779 -1.218,-1.837 -1.218,-2.94c0,-7.079 0,-20.714 0,-20.714l27.526,0.861Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M531.261,1854.55c-0.056,-0.031 -0.117,-0.048 -0.18,-0.05l-27.527,-0.862c-0.106,-0.003 -0.209,0.037 -0.285,0.111c-0.077,0.074 -0.12,0.175 -0.12,0.282c0,-0 0,13.635 0,20.714c0,1.207 0.48,2.365 1.333,3.218c0.854,0.854 2.012,1.333 3.219,1.333c9.522,0 33.343,0 49.639,0c2.142,0 4.014,-1.445 4.555,-3.517c0.542,-2.072 -0.383,-4.249 -2.25,-5.297c-12.423,-6.973 -28.384,-15.932 -28.384,-15.932Zm-0.301,0.732l28.3,15.885c1.556,0.873 2.327,2.687 1.875,4.413c-0.451,1.726 -2.011,2.931 -3.795,2.931c-16.296,-0 -40.117,-0 -49.639,-0c-0.999,-0 -1.957,-0.397 -2.663,-1.103c-0.706,-0.707 -1.103,-1.664 -1.103,-2.663c-0,-0 -0,-20.309 -0,-20.309l27.025,0.846Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M531.068,1830.76l0,24.132c0,0 -14.167,13.359 -27.526,0l0,-23.023l27.526,-1.109Z",
    style: {
      fill: "rgb(225,110,110)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M531.461,1830.76c0,-0.107 -0.044,-0.209 -0.121,-0.283c-0.077,-0.074 -0.181,-0.113 -0.288,-0.109l-27.526,1.108c-0.21,0.009 -0.377,0.182 -0.377,0.393l0,23.023c0,0.105 0.042,0.205 0.115,0.278c13.625,13.625 28.074,0.008 28.074,0.008c0.078,-0.074 0.123,-0.177 0.123,-0.286l0,-24.132Zm-0.786,0.409l0,23.55c-1.397,1.246 -14.401,12.2 -26.74,0.011c-0,-0.001 -0,-22.484 -0,-22.484l26.74,-1.077Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M469.787,1665.51l2.158,-32.003l-17.853,7.387l-18.674,-42.682c0,-0 17.012,-9.176 26.918,-14.52c4.569,-2.464 9.633,-3.87 14.818,-4.113c14.05,-0.659 43.608,-2.046 61.202,-2.871c8.996,-0.422 17.804,2.677 24.553,8.641c8.792,7.769 19.898,17.582 19.898,17.582l-21.804,26.882l-12.224,-3.283l5.042,32.833l-84.034,6.147Z",
    style: {
      fill: "rgb(81,148,234)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M469.787,1665.51l0.166,-2.458l72.163,-2.833l-72.329,5.291Zm83.273,-11.103l-82.744,3.248l0.216,-3.191l82.042,-3.221l0.486,3.164Zm-1.307,-8.514l-80.858,3.175l0.216,-3.191l80.156,-3.147l0.486,3.163Zm-97.661,-4.999l-1.207,-2.757l8.695,-0.341l-7.488,3.098Zm96.37,-3.405l-78.995,3.101l0.215,-3.191l78.294,-3.074l0.486,3.164Zm-1.307,-8.514l-98.585,3.87l-1.369,-3.128l115.561,-4.538l-2.666,3.288l-5.328,0.209l-7.989,-2.146l0.376,2.445Zm20.116,-9.355l-122.385,4.805l-1.368,-3.129l126.42,-4.963l-2.667,3.287Zm7.028,-8.665l-133.021,5.223l-1.369,-3.129l137.056,-5.381l-2.666,3.287Zm6.508,-8.024l-0.007,0.009l-142.859,5.609l-1.369,-3.129l140.796,-5.528l3.439,3.039Zm-146.578,-5.157l134.754,-5.29l3.449,3.047l-137.819,5.411l-1.195,-2.73l0.811,-0.438Zm126.337,-12.698c0.332,0.273 0.66,0.553 0.984,0.839l2.497,2.207l-120.71,4.74l6.364,-3.433l110.865,-4.353Zm-11.895,-6.539c2.294,0.752 4.513,1.73 6.623,2.922l-97.948,3.846l2.568,-1.385c1.481,-0.799 3.01,-1.492 4.577,-2.078l84.18,-3.305Z",
    style: {
      fill: "rgb(87,192,248)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M469.395,1665.48c-0.008,0.114 0.034,0.225 0.115,0.305c0.081,0.08 0.192,0.121 0.305,0.113l84.035,-6.148c0.109,-0.008 0.21,-0.061 0.278,-0.147c0.069,-0.085 0.098,-0.196 0.081,-0.304l-4.95,-32.237c-0,-0 11.642,3.127 11.642,3.127c0.15,0.04 0.31,-0.012 0.407,-0.132l21.804,-26.882c0.133,-0.164 0.113,-0.402 -0.045,-0.542c0,0 -11.106,-9.814 -19.898,-17.582c-6.826,-6.032 -15.733,-9.166 -24.832,-8.739c-17.594,0.825 -47.151,2.212 -61.201,2.871c-5.244,0.246 -10.366,1.667 -14.986,4.16c-9.907,5.343 -26.918,14.519 -26.918,14.519c-0.18,0.097 -0.256,0.316 -0.174,0.503l18.674,42.683c0.086,0.196 0.312,0.287 0.51,0.205l17.268,-7.145c0,-0 -2.115,31.372 -2.115,31.372Zm0.814,-0.398l2.127,-31.553c0.01,-0.135 -0.052,-0.266 -0.162,-0.345c-0.111,-0.079 -0.254,-0.096 -0.38,-0.044l-17.497,7.24c0,0 -18.374,-41.998 -18.374,-41.998c-0,-0 26.6,-14.348 26.6,-14.348c4.517,-2.436 9.523,-3.826 14.649,-4.067c14.051,-0.659 43.608,-2.045 61.202,-2.871c8.895,-0.417 17.602,2.647 24.275,8.544c0,-0 19.616,17.333 19.616,17.333c-0,-0 -21.406,26.391 -21.406,26.391c-0,-0 -11.978,-3.217 -11.978,-3.217c-0.128,-0.035 -0.265,-0.002 -0.364,0.086c-0.099,0.089 -0.146,0.221 -0.126,0.353l4.977,32.412l-83.159,6.084Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M472.335,1633.55l0.9,-9.206c0.021,-0.216 -0.137,-0.408 -0.353,-0.429c-0.215,-0.021 -0.408,0.137 -0.429,0.353l-0.899,9.206c-0.021,0.216 0.137,0.408 0.352,0.429c0.216,0.021 0.408,-0.137 0.429,-0.353Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M549.167,1626.47l-3.872,-24.468c-0.033,-0.214 -0.235,-0.361 -0.449,-0.327c-0.214,0.034 -0.36,0.236 -0.326,0.45l3.871,24.467c0.034,0.215 0.236,0.361 0.45,0.327c0.214,-0.034 0.36,-0.235 0.326,-0.449Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M493.712,1541.49c-0,0 -0.371,11.626 -0.561,17.579c-0.061,1.925 1.387,3.564 3.304,3.741c1.776,0.164 3.58,0.331 3.58,0.331l1.614,-22.432c-0,0 -6.675,-3.71 -7.937,0.781Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M493.334,1541.39c-0.009,0.03 -0.014,0.062 -0.015,0.094c0,-0 -0.371,11.625 -0.561,17.579c-0.068,2.132 1.537,3.948 3.661,4.144c1.776,0.164 3.58,0.331 3.58,0.331c0.105,0.01 0.209,-0.023 0.29,-0.092c0.08,-0.068 0.13,-0.166 0.138,-0.271l1.613,-22.432c0.011,-0.152 -0.067,-0.297 -0.201,-0.371c0,-0 -2.494,-1.381 -4.771,-1.483c-1.641,-0.074 -3.168,0.486 -3.734,2.501Zm0.769,0.167c0.454,-1.54 1.657,-1.94 2.93,-1.883c1.724,0.077 3.58,0.95 4.205,1.269c0,-0 -1.566,21.776 -1.566,21.776c-0,-0 -3.181,-0.294 -3.181,-0.294c-1.71,-0.158 -3.002,-1.62 -2.947,-3.337l0.559,-17.531Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.3156,0.528338,-0.528338,2.3156,27948.2,-3924.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1111.9,1679.85c-0.04,-0.176 -6.172,-38.375 -6.172,-38.375l36.866,0c0,0 8.402,37.562 8.59,38.375c2.515,10.901 -4.244,19.751 -15.084,19.751c-10.841,-0 -21.684,-8.85 -24.2,-19.751Z",
    style: {
      fill: "rgb(225,110,110)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.3156,0.528338,-0.528338,2.3156,27948.2,-3924.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1111.32,1679.99c2.576,11.161 13.685,20.216 24.785,20.216c5.629,-0 10.192,-2.311 13.027,-6.024c2.829,-3.703 3.945,-8.815 2.642,-14.462c-0.188,-0.813 -8.589,-38.371 -8.589,-38.371c-0.061,-0.274 -0.305,-0.469 -0.586,-0.469l-36.866,0c-0.176,0 -0.343,0.077 -0.457,0.211c-0.114,0.134 -0.164,0.311 -0.136,0.485c0,-0 6.14,38.238 6.18,38.414Zm1.17,-0.27c-0.037,-0.162 -5.223,-32.466 -6.053,-37.639c0,-0 35.682,-0 35.682,-0c0.968,4.327 8.31,37.15 8.485,37.909c1.212,5.254 0.206,10.017 -2.426,13.464c-2.625,3.437 -6.862,5.551 -12.073,5.551c-10.582,0 -21.16,-8.645 -23.615,-19.285Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.37251,0.111159,-0.0927435,1.97946,27282.7,-2821.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1071.24,1633.02c6.29,4.949 13.697,7.644 21.335,7.644l0.002,-0c12.408,-0 22.466,-12.056 22.466,-26.927l-0,-32.52c-0,-9.75 -3.231,-19.1 -8.983,-25.994c-5.752,-6.893 -13.553,-10.766 -21.687,-10.766c-0.001,-0 -0.001,-0 -0.002,-0c-8.134,-0 -15.935,3.873 -21.687,10.766c-5.751,6.894 -8.983,16.244 -8.983,25.994c0,4.208 0,8.539 0,12.854",
    style: {
      fill: "rgb(225,110,110)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.37251,0.111159,-0.0927435,1.97946,27282.7,-2821.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1070.91,1633.62c6.387,5.026 13.908,7.762 21.664,7.762l0.002,-0c12.739,-0 23.066,-12.378 23.066,-27.646c0,-10.078 0,-21.705 0,-32.52c0,-9.94 -3.294,-19.473 -9.159,-26.502c-5.864,-7.029 -13.818,-10.978 -22.111,-10.978c-0.001,0 -0.001,0 -0.002,0c-8.293,0 -16.247,3.949 -22.111,10.978c-5.864,7.029 -9.159,16.562 -9.159,26.502c0,4.208 0,8.539 0,12.854c0,0.397 0.269,0.719 0.6,0.719c0.331,-0 0.6,-0.322 0.6,-0.719l0,-12.854c0,-9.559 3.168,-18.726 8.808,-25.485c5.639,-6.759 13.287,-10.556 21.262,-10.556c0.001,0 0.001,0 0.002,0c7.975,0 15.623,3.797 21.263,10.556c5.639,6.759 8.807,15.926 8.807,25.485c-0,10.815 -0,22.442 -0,32.52c-0,14.474 -9.79,26.207 -21.866,26.207c-0.001,0 -0.001,0 -0.002,0c-7.52,0 -14.812,-2.652 -21.005,-7.526c-0.277,-0.218 -0.65,-0.125 -0.831,0.207c-0.182,0.332 -0.105,0.778 0.172,0.996Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.23031,0,0,3.62915,26465.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M522,1564.01l6.255,-0c0.126,-0 0.228,-0.176 0.228,-0.393c0,-0.217 -0.102,-0.393 -0.228,-0.393l-6.255,0c-0.126,0 -0.229,0.176 -0.229,0.393c0,0.217 0.103,0.393 0.229,0.393Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M504.395,1540.54c-0,0 0.7,7.021 1.091,10.935c0.067,0.669 -0.143,1.336 -0.579,1.847c-0.437,0.511 -1.064,0.822 -1.735,0.86c-1.027,0.059 -1.971,0.112 -1.971,0.112l-2.132,-9.438l-3.335,-0l1.197,-4.924l7.464,0.608Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M504.785,1540.51c-0.018,-0.188 -0.169,-0.337 -0.359,-0.352l-7.463,-0.609c-0.192,-0.016 -0.368,0.111 -0.413,0.299l-1.198,4.924c-0.028,0.117 -0.001,0.241 0.073,0.336c0.075,0.094 0.188,0.15 0.309,0.15l3.021,-0c0,-0 2.063,9.132 2.063,9.132c0.043,0.187 0.214,0.316 0.406,0.305c-0,0 0.943,-0.053 1.97,-0.112c0.778,-0.044 1.505,-0.404 2.011,-0.996c0.507,-0.593 0.749,-1.366 0.672,-2.142l-1.092,-10.935Zm-0.749,0.404l1.059,10.609c0.056,0.563 -0.12,1.124 -0.487,1.553c-0.367,0.43 -0.894,0.691 -1.458,0.723l-1.639,0.093c0,0 -2.059,-9.114 -2.059,-9.114c-0.04,-0.179 -0.199,-0.306 -0.383,-0.306l-2.835,0c-0,0 1,-4.113 1,-4.113l6.802,0.555Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M493.712,1541.49c-0,0 18.006,0.909 43.649,2.119c0,-0 3.684,-20.526 -20.204,-22.745c0,-0 -21.478,-2.101 -23.445,20.626Z",
    style: {
      fill: "rgb(80,149,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M493.321,1541.46c-0.01,0.106 0.025,0.212 0.095,0.292c0.07,0.081 0.17,0.129 0.276,0.134c0,0 18.007,0.909 43.651,2.119c0.197,0.009 0.37,-0.129 0.405,-0.323c-0,-0 1.353,-7.54 -2.829,-14.061c-2.78,-4.336 -8.003,-8.241 -17.725,-9.144c0.001,-0 -10.715,-1.044 -17.832,6.265c-3.046,3.128 -5.441,7.785 -6.041,14.718Zm0.82,-0.338c0.636,-6.48 2.899,-10.869 5.784,-13.832c6.861,-7.046 17.194,-6.031 17.194,-6.031c0.001,-0 0.001,-0 0.002,-0c9.387,0.872 14.452,4.6 17.137,8.786c3.5,5.457 2.962,11.658 2.767,13.158c-23.209,-1.095 -40.089,-1.94 -42.884,-2.081l-0,0Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M547.269,1544.09c-0,0 7.614,0.658 8.203,-3.358l-18.089,-3.765c0,-0 -10.014,5.575 -27.967,5.306l37.853,1.817Z",
    style: {
      fill: "rgb(80,149,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M547.244,1544.48c0.178,0.015 2.889,0.218 5.196,-0.456c1.699,-0.497 3.162,-1.473 3.42,-3.237c0.031,-0.206 -0.105,-0.399 -0.308,-0.441l-18.089,-3.766c-0.092,-0.019 -0.188,-0.004 -0.271,0.041c0,0 -9.945,5.524 -27.77,5.257c-0.215,-0.003 -0.392,0.166 -0.399,0.38c-0.006,0.215 0.16,0.395 0.374,0.405l37.847,1.817Zm0.058,-0.783c-0.005,-0 -0.01,-0.001 -0.015,-0.001l-28.933,-1.389c11.433,-1.113 18.094,-4.408 19.09,-4.929c-0.001,0 17.561,3.656 17.561,3.656c-0.353,1.213 -1.512,1.864 -2.785,2.236c-2.254,0.659 -4.918,0.427 -4.918,0.427Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.09819,0.456679,-0.477742,2.19497,28184.3,-3520.44)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1055.6,
    cy: 1592.97,
    r: 8.94,
    style: {
      fill: "rgb(225,110,110)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.32077,0.505124,-0.505124,2.32077,27899.9,-3896.15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1109.58,1641.91c-1.268,1.042 -2.867,1.665 -4.603,1.665c-4.137,-0 -7.483,-3.528 -7.483,-7.856c0,-4.337 3.337,-8.289 7.483,-8.289c0.331,0 0.6,-0.269 0.6,-0.6c0,-0.331 -0.269,-0.6 -0.6,-0.6c-4.776,-0 -8.683,4.493 -8.683,9.489c0,5.006 3.898,9.056 8.683,9.056c2.023,-0 3.887,-0.723 5.365,-1.937c0.256,-0.21 0.293,-0.589 0.083,-0.845c-0.21,-0.256 -0.589,-0.293 -0.845,-0.083Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M563.02,1627.33c-0,0 19.582,9.972 33.582,17.1c2.813,1.433 6.18,1.236 8.808,-0.514c2.627,-1.75 4.106,-4.781 3.869,-7.929c-1.548,-20.511 -4.084,-54.111 -4.084,-54.111l-22.388,-11.163l0,32.221l-19.787,24.396Z",
    style: {
      fill: "rgb(225,110,110)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M562.715,1627.08c-0.075,0.092 -0.104,0.213 -0.079,0.329c0.024,0.116 0.1,0.214 0.205,0.268c0,0 19.583,9.972 33.582,17.1c2.94,1.497 6.459,1.292 9.204,-0.537c2.746,-1.828 4.292,-4.996 4.043,-8.286c-1.548,-20.51 -4.083,-54.111 -4.083,-54.111c-0.011,-0.138 -0.093,-0.26 -0.217,-0.322l-22.388,-11.163c-0.121,-0.06 -0.266,-0.054 -0.382,0.018c-0.115,0.071 -0.186,0.198 -0.186,0.334l0,32.082c0,0 -19.699,24.288 -19.699,24.288Zm0.916,0.118l19.481,-24.019c0.057,-0.07 0.088,-0.157 0.088,-0.248l-0,-31.586c-0,-0 21.62,10.78 21.62,10.78c0,-0 4.067,53.888 4.067,53.888c0.227,3.007 -1.186,5.902 -3.695,7.574c-2.51,1.671 -5.725,1.859 -8.412,0.49l-33.149,-16.879Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62701,0.12456,-0.12456,3.62701,28025.9,-5233.24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M531.457,1555.02c-2.391,-0.65 -4.118,-2.318 -4.118,-4.666c0,-2.466 2.003,-4.258 4.469,-4.258c0.217,-0 19.214,1.369 19.214,1.369l-2.367,11.458l-17.198,-3.903Z",
    style: {
      fill: "rgb(252,201,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62701,0.12456,-0.12456,3.62701,28025.9,-5233.24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M531.354,1555.4c0.005,0.001 0.01,0.002 0.016,0.004l17.198,3.903c0.103,0.024 0.211,0.005 0.3,-0.053c0.089,-0.057 0.151,-0.147 0.172,-0.25l2.367,-11.458c0.023,-0.111 -0.003,-0.226 -0.072,-0.317c-0.068,-0.09 -0.172,-0.146 -0.285,-0.154c0,-0 -19.024,-1.371 -19.242,-1.371c-2.688,0 -4.861,1.963 -4.861,4.651c-0,2.528 1.833,4.345 4.407,5.045Zm0.198,-0.761c-2.204,-0.601 -3.82,-2.118 -3.82,-4.284c0,-2.244 1.832,-3.865 4.076,-3.865c0.197,-0 15.873,1.129 18.739,1.336c-0,-0 -2.195,10.626 -2.195,10.626l-16.8,-3.813Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M552.064,1564.32c-4.842,-1.414 -8.124,-5.573 -7.895,-9.883c0.276,-5.184 4.215,-8.81 9.407,-8.81c0.337,0 32.551,1.711 32.551,1.711l-2.807,27.399l-31.256,-10.417Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M551.946,1564.69l31.25,10.415c0.113,0.038 0.237,0.022 0.337,-0.042c0.1,-0.065 0.166,-0.172 0.178,-0.29l2.807,-27.399c0.011,-0.107 -0.023,-0.213 -0.093,-0.295c-0.07,-0.082 -0.17,-0.131 -0.277,-0.137c-0,-0 -32.235,-1.711 -32.572,-1.711c-5.409,-0 -9.511,3.78 -9.799,9.182c-0.238,4.475 3.149,8.812 8.176,10.28l-0.007,-0.003Zm0.242,-0.747c-0.005,-0.002 -0.01,-0.003 -0.014,-0.004c-4.655,-1.359 -7.833,-5.341 -7.612,-9.485c0.264,-4.967 4.04,-8.438 9.014,-8.438c0.314,0 28.371,1.49 32.118,1.689c0,-0 -2.715,26.5 -2.715,26.5c0,0 -30.791,-10.262 -30.791,-10.262Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62143,0.236474,-0.236474,3.62143,28205.1,-5295.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M589.963,1545.63l40.527,-1.692l-5.096,45.799l-37.659,-10.833c-7.908,-1.343 -13.938,-8.235 -13.938,-16.523c0,-9.051 7.19,-16.436 16.166,-16.751Z",
    style: {
      fill: "rgb(252,201,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62143,0.236474,-0.236474,3.62143,28205.1,-5295.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M589.947,1545.24c-9.185,0.323 -16.542,7.88 -16.542,17.143c-0,8.476 6.161,15.525 14.245,16.908c-0.003,-0.001 37.636,10.826 37.636,10.826c0.111,0.032 0.231,0.013 0.327,-0.051c0.096,-0.065 0.159,-0.168 0.172,-0.283c-0,-0 5.095,-45.799 5.095,-45.799c0.013,-0.114 -0.025,-0.228 -0.103,-0.312c-0.078,-0.083 -0.189,-0.129 -0.304,-0.124l-40.526,1.692Zm0.03,0.785l40.072,-1.673c-0,-0 -4.993,44.881 -4.993,44.881c-0,0 -37.213,-10.704 -37.213,-10.704c-0.014,-0.004 -0.028,-0.007 -0.043,-0.01c-7.722,-1.312 -13.61,-8.042 -13.61,-16.136c0,-8.839 7.021,-16.051 15.787,-16.358Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62143,0.236474,-0.236474,3.62143,28199.4,-5278.48)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 631.76,
    cy: 1562.38,
    r: 23.17,
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62143,0.236474,-0.236474,3.62143,28199.4,-5278.48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M631.76,1538.82c-13.004,-0 -23.563,10.558 -23.563,23.563c0,13.004 10.559,23.563 23.563,23.563c13.005,-0 23.563,-10.559 23.563,-23.563c0,-13.005 -10.558,-23.563 -23.563,-23.563l0,-0Zm0,0.785c12.571,0 22.778,10.207 22.778,22.778c-0,12.571 -10.207,22.777 -22.778,22.777c-12.571,-0 -22.777,-10.206 -22.777,-22.777c-0,-12.571 10.206,-22.778 22.777,-22.778l0,0Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.61974,0.171065,-0.171065,2.61974,28730,-3672.11)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 631.76,
    cy: 1562.38,
    r: 23.17,
    style: {
      fill: "rgb(252,201,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.61974,0.171065,-0.171065,2.61974,28730,-3672.11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M631.76,1538.67c-13.087,-0 -23.713,10.625 -23.713,23.713c0,13.087 10.626,23.713 23.713,23.713c13.088,-0 23.713,-10.626 23.713,-23.713c0,-13.088 -10.625,-23.713 -23.713,-23.713l0,-0Zm0,1.086c12.489,-0 22.627,10.138 22.627,22.627c0,12.488 -10.138,22.627 -22.627,22.627c-12.488,-0 -22.627,-10.139 -22.627,-22.627c0,-12.489 10.139,-22.627 22.627,-22.627l0,-0Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.887,1561.47l80.637,-12.476l7.932,47.641l-76.224,8.043l-12.345,-43.208Z",
    style: {
      fill: "rgb(225,172,137)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.827,1561.08c-0.111,0.017 -0.21,0.082 -0.271,0.177c-0.061,0.095 -0.078,0.211 -0.047,0.319l12.345,43.208c0.053,0.183 0.229,0.303 0.419,0.283l76.224,-8.043c0.108,-0.011 0.206,-0.067 0.272,-0.153c0.065,-0.086 0.092,-0.195 0.075,-0.302l-7.933,-47.641c-0.035,-0.213 -0.235,-0.357 -0.447,-0.324l-80.637,12.476Zm0.56,0.708l79.813,-12.348c0,-0 7.8,46.847 7.8,46.847c0,-0 -75.481,7.964 -75.481,7.964l-12.132,-42.463Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.887,1561.47l23.208,-17.476l73.151,-10.9l-15.722,15.9l-80.637,12.476Z",
    style: {
      fill: "rgb(251,231,217)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.651,1561.16c-0.144,0.108 -0.196,0.3 -0.126,0.466c0.07,0.166 0.244,0.263 0.422,0.236l80.637,-12.477c0.083,-0.013 0.16,-0.052 0.219,-0.112l15.722,-15.9c0.119,-0.12 0.148,-0.303 0.071,-0.454c-0.076,-0.151 -0.241,-0.236 -0.408,-0.211l-73.151,10.901c-0.065,0.009 -0.126,0.035 -0.178,0.074l-23.208,17.477Zm1.722,-0.314l21.878,-16.475c0,-0 71.886,-10.712 71.886,-10.712c0,-0 -14.801,14.97 -14.801,14.97l-78.963,12.217Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464.651,1582.87l-16.195,13.767l-7.932,-47.641l15.722,-15.9l8.405,49.774Z",
    style: {
      fill: "rgb(245,209,187)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464.905,1583.17c0.106,-0.09 0.156,-0.228 0.133,-0.365l-8.405,-49.774c-0.024,-0.145 -0.128,-0.264 -0.269,-0.309c-0.14,-0.044 -0.294,-0.006 -0.398,0.098l-15.722,15.901c-0.088,0.089 -0.128,0.216 -0.108,0.341c0,-0 7.933,47.641 7.933,47.641c0.023,0.139 0.119,0.256 0.252,0.304c0.133,0.049 0.282,0.022 0.39,-0.069l16.194,-13.768Zm-0.679,-0.454l-15.496,13.174c-0,0 -7.786,-46.76 -7.786,-46.76c0,0 15.042,-15.212 15.042,-15.212l8.24,48.798Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.882,1553.94l77.18,-11.562l3.511,19.088l1.207,-6.845l1.681,1.547l-0.068,-3.295l1.614,1.143l-2.927,-16.713l-74.788,11.057l-7.41,5.58Z",
    style: {
      fill: "rgb(254,255,254)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.646,1553.63c-0.144,0.108 -0.196,0.3 -0.126,0.466c0.069,0.165 0.243,0.263 0.42,0.236l76.805,-11.506c-0,0 3.442,18.715 3.442,18.715c0.035,0.187 0.198,0.323 0.388,0.322c0.19,-0.001 0.352,-0.137 0.385,-0.324c0,-0 1.082,-6.139 1.082,-6.139c-0,0 1.153,1.061 1.153,1.061c0.115,0.106 0.284,0.134 0.427,0.069c0.143,-0.065 0.234,-0.209 0.231,-0.366l-0.051,-2.516c-0,-0 0.978,0.693 0.978,0.693c0.13,0.092 0.303,0.096 0.437,0.011c0.135,-0.085 0.204,-0.243 0.177,-0.4l-2.927,-16.713c-0.037,-0.21 -0.234,-0.352 -0.444,-0.321l-74.789,11.057c-0.065,0.01 -0.126,0.036 -0.179,0.075l-7.409,5.58Zm1.71,-0.304l6.092,-4.588c0,-0 74.311,-10.987 74.311,-10.987c0,0 2.697,15.397 2.697,15.397c-0,0 -0.836,-0.592 -0.836,-0.592c-0.121,-0.085 -0.28,-0.095 -0.411,-0.026c-0.131,0.069 -0.211,0.207 -0.208,0.355l0.048,2.375c0,-0 -1.004,-0.924 -1.004,-0.924c-0.105,-0.097 -0.255,-0.129 -0.391,-0.083c-0.136,0.046 -0.236,0.163 -0.261,0.304l-0.828,4.697c0,0 -3.117,-16.944 -3.117,-16.944c-0.038,-0.208 -0.235,-0.348 -0.444,-0.317c-0,0 -75.648,11.333 -75.648,11.333Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435.418,1598.21c0,-0 -13.797,-12.516 -19.33,-17.536c-1.398,-1.268 -2.025,-3.18 -1.649,-5.03c0.27,-1.327 0.575,-2.831 0.796,-3.917c0.199,-0.983 0.119,-2.002 -0.232,-2.941c-1.029,-2.752 -3.289,-8.795 -4.57,-12.22c-0.588,-1.572 -0.405,-3.329 0.496,-4.746c2.719,-4.278 8.366,-13.163 8.366,-13.163c-0,-0 0.81,-1.82 -0.981,-1.854c-1.246,-0.024 -3.615,2.41 -3.615,2.41c0,-0 0.655,-2.41 -1.101,-2.238c-1.756,0.172 -3.374,2.341 -3.374,2.341c-0,-0 0.447,-2.272 -1.412,-2.135c-1.859,0.138 -3.58,2.376 -3.58,2.376c-0,-0 0.895,-2.169 -1.171,-2.066c-2.065,0.103 -4.303,2.995 -4.303,2.995c-0,0 -8.166,8.098 -12.832,12.724c-1.979,1.962 -2.834,4.791 -2.273,7.521c1.486,7.242 4.375,21.32 5.198,25.331c0.148,0.719 0.442,1.4 0.864,2.001c4.108,5.848 26.908,38.306 36.317,51.701c2.389,3.401 6.782,4.744 10.665,3.262c6.374,-2.434 15.067,-5.753 15.067,-5.753l-17.346,-39.063Z",
    style: {
      fill: "rgb(225,110,110)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.803,1538.37c-0.029,-0.253 -0.109,-0.499 -0.262,-0.706c-0.248,-0.335 -0.694,-0.599 -1.499,-0.559c-0.901,0.045 -1.838,0.561 -2.63,1.182c-1.045,0.819 -1.837,1.804 -1.951,1.947c0.003,-0.004 -12.811,12.703 -12.811,12.703c-2.073,2.056 -2.969,5.019 -2.382,7.879c1.486,7.242 4.375,21.32 5.199,25.331c0.158,0.772 0.473,1.503 0.926,2.147c4.109,5.849 26.909,38.307 36.318,51.702c2.492,3.547 7.075,4.949 11.126,3.403c6.374,-2.434 15.067,-5.753 15.067,-5.753c0.101,-0.039 0.181,-0.117 0.223,-0.216c0.041,-0.1 0.04,-0.212 -0.004,-0.31l-17.346,-39.064c-0.022,-0.05 -0.054,-0.094 -0.095,-0.131c0,-0 -13.797,-12.516 -19.33,-17.535c-1.295,-1.176 -1.876,-2.947 -1.528,-4.662c0.27,-1.326 0.575,-2.83 0.796,-3.917c0.214,-1.055 0.128,-2.149 -0.249,-3.157c-1.029,-2.751 -3.289,-8.794 -4.57,-12.219c-0.545,-1.457 -0.375,-3.086 0.459,-4.399c2.719,-4.278 8.366,-13.162 8.366,-13.162l-0,-0c0.013,-0.02 0.024,-0.043 0.035,-0.067c0.027,-0.065 0.166,-0.41 0.201,-0.806c0.03,-0.337 -0.02,-0.704 -0.223,-0.999c-0.214,-0.312 -0.603,-0.572 -1.317,-0.586c-0.433,-0.008 -0.99,0.219 -1.548,0.57c-0.558,0.352 -1.126,0.819 -1.564,1.209c-0.002,-0.065 -0.006,-0.132 -0.012,-0.198c-0.045,-0.463 -0.217,-0.904 -0.581,-1.168c-0.246,-0.178 -0.585,-0.285 -1.058,-0.239c-0.774,0.076 -1.528,0.494 -2.15,0.98c-0.295,0.231 -0.559,0.476 -0.781,0.7c-0.009,-0.05 -0.018,-0.101 -0.029,-0.151c-0.078,-0.355 -0.239,-0.701 -0.522,-0.951c-0.284,-0.25 -0.693,-0.417 -1.294,-0.372c-0.816,0.06 -1.613,0.479 -2.27,0.973c-0.262,0.197 -0.501,0.404 -0.71,0.601Zm-0.932,1.038c-0,0 0.134,-0.355 0.157,-0.691c0.014,-0.2 0.004,-0.42 -0.119,-0.586c-0.134,-0.181 -0.394,-0.263 -0.828,-0.242c-0.752,0.038 -1.523,0.497 -2.185,1.016c-1.051,0.824 -1.827,1.828 -1.827,1.828c-0.011,0.013 -0.022,0.026 -0.035,0.038c0,0 -8.165,8.098 -12.831,12.724c-1.885,1.869 -2.699,4.563 -2.166,7.163c1.487,7.242 4.376,21.32 5.199,25.331c0.137,0.666 0.409,1.297 0.8,1.854c4.108,5.848 26.908,38.306 36.318,51.701c2.285,3.254 6.488,4.539 10.203,3.121c-0,0 14.68,-5.605 14.68,-5.605l-17.144,-38.609l-19.268,-17.48c-1.501,-1.361 -2.174,-3.413 -1.771,-5.399c0.27,-1.327 0.575,-2.831 0.796,-3.917c0.185,-0.911 0.11,-1.855 -0.215,-2.725c-1.029,-2.752 -3.289,-8.795 -4.57,-12.22c-0.631,-1.688 -0.434,-3.574 0.533,-5.095l8.346,-13.133c0.026,-0.067 0.115,-0.312 0.136,-0.55c0.014,-0.162 0.01,-0.343 -0.088,-0.485c-0.108,-0.157 -0.325,-0.239 -0.685,-0.246c-0.316,-0.006 -0.708,0.194 -1.114,0.45c-1.089,0.685 -2.212,1.841 -2.212,1.841c-0.125,0.129 -0.321,0.156 -0.476,0.068c-0.156,-0.089 -0.232,-0.272 -0.185,-0.444c0,-0 0.145,-0.531 0.096,-1.043c-0.022,-0.235 -0.075,-0.474 -0.26,-0.607c-0.119,-0.087 -0.29,-0.117 -0.52,-0.094c-0.63,0.061 -1.236,0.42 -1.742,0.816c-0.802,0.628 -1.355,1.369 -1.355,1.369c-0.11,0.147 -0.307,0.198 -0.474,0.124c-0.168,-0.075 -0.262,-0.255 -0.227,-0.435c0,-0 0.097,-0.487 -0.006,-0.959c-0.043,-0.196 -0.119,-0.392 -0.275,-0.53c-0.155,-0.137 -0.387,-0.202 -0.716,-0.178c-0.67,0.05 -1.317,0.413 -1.856,0.818c-0.853,0.641 -1.442,1.405 -1.442,1.405l-0.001,0.002c-0.124,0.163 -0.31,0.152 -0.31,0.152l-0.361,-0.548Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404.932,1539.31l-8.957,10.557c-0.14,0.166 -0.12,0.414 0.046,0.554c0.165,0.14 0.413,0.12 0.553,-0.046l8.957,-10.557c0.141,-0.165 0.12,-0.413 -0.045,-0.554c-0.165,-0.14 -0.413,-0.12 -0.554,0.046Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.92,1539.07l-9.99,12.175c-0.137,0.168 -0.113,0.416 0.055,0.553c0.167,0.138 0.415,0.113 0.553,-0.054l9.99,-12.176c0.137,-0.168 0.113,-0.415 -0.055,-0.553c-0.168,-0.137 -0.415,-0.113 -0.553,0.055Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414.382,1538.98l-9.646,13.268c-0.127,0.176 -0.089,0.421 0.087,0.549c0.175,0.127 0.421,0.088 0.548,-0.087l9.646,-13.268c0.128,-0.176 0.089,-0.422 -0.087,-0.549c-0.175,-0.128 -0.421,-0.089 -0.548,0.087Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470.01,1662.71c0,0 85.306,-5.575 124.474,-8.135c11.224,-0.734 21.432,6.48 24.488,17.304c6.661,23.59 17.304,61.283 17.304,61.283l-51.195,2.348l-4.227,-30.999l-49.786,10.803l0,123.995l-75.148,-0l14.09,-176.599Z",
    style: {
      fill: "rgb(134,212,251)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M469.985,1662.32c-0.195,0.013 -0.351,0.167 -0.366,0.361l-14.091,176.598c-0.008,0.11 0.029,0.217 0.103,0.298c0.075,0.081 0.179,0.126 0.289,0.126l75.148,0c0.217,0 0.393,-0.176 0.393,-0.392l0,-123.678c0,-0 49.061,-10.646 49.061,-10.646c0,0 4.17,30.578 4.17,30.578c0.027,0.202 0.204,0.349 0.407,0.339l51.195,-2.348c0.12,-0.006 0.23,-0.065 0.3,-0.163c0.07,-0.097 0.092,-0.221 0.06,-0.336c-0,-0 -10.643,-37.693 -17.304,-61.283c-3.106,-11.003 -13.483,-18.335 -24.891,-17.589c-39.169,2.56 -124.474,8.135 -124.474,8.135Zm0.39,0.762l124.135,-8.113c11.039,-0.722 21.079,6.373 24.084,17.019c0,-0 17.169,60.806 17.169,60.806c0,-0 -50.341,2.309 -50.341,2.309c-0,0 -4.179,-30.643 -4.179,-30.643c-0.015,-0.108 -0.074,-0.206 -0.164,-0.268c-0.089,-0.063 -0.201,-0.086 -0.308,-0.062l-49.786,10.802c-0.181,0.039 -0.31,0.199 -0.31,0.384l0,123.602c0,-0 -74.33,-0 -74.33,-0l14.03,-175.836Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M484.763,1670.13c0,-0 0.906,4.031 0.15,8.414c-0.746,4.329 -3.129,9.011 -9.698,10.405c-0.17,0.036 -0.296,0.18 -0.31,0.353l-11.696,149.972c-0.017,0.216 0.144,0.405 0.361,0.422c0.216,0.017 0.405,-0.145 0.422,-0.361l11.674,-149.682c6.758,-1.553 9.24,-6.442 10.022,-10.975c0.783,-4.543 -0.158,-8.721 -0.158,-8.721c-0.048,-0.211 -0.258,-0.344 -0.47,-0.297c-0.211,0.048 -0.344,0.258 -0.297,0.47Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M607.32,1705.46c32.309,-0 58.54,26.231 58.54,58.54c0,71.687 -58.54,114.901 -58.54,114.901c-0,0 -58.541,-45.919 -58.541,-114.901c0,-32.309 26.231,-58.54 58.541,-58.54Z",
    style: {
      fill: "rgb(246,112,46)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M607.32,1705.07c-32.526,-0 -58.933,26.407 -58.933,58.933c-0,69.166 58.69,115.21 58.69,115.21c0.139,0.109 0.334,0.112 0.476,0.007c0,0 58.7,-43.333 58.7,-115.217c-0,-32.526 -26.407,-58.933 -58.933,-58.933Zm-0,0.785c32.092,0 58.147,26.056 58.147,58.148c0,68.807 -54.081,111.311 -58.14,114.404c-4.021,-3.244 -58.155,-48.161 -58.155,-114.404c0,-32.092 26.055,-58.148 58.148,-58.148Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.90544,0,0,2.90544,28237,-3899.45)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 618.976,
    cy: 1772.59,
    r: 36.169,
    style: {
      fill: "rgb(252,201,59)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.90544,0,0,2.90544,28237,-3899.45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M618.976,1735.93c-20.233,0 -36.66,16.427 -36.66,36.659c0,20.233 16.427,36.66 36.66,36.66c20.233,-0 36.659,-16.427 36.659,-36.66c0,-20.232 -16.426,-36.659 -36.659,-36.659Zm-0,0.981c19.691,0 35.678,15.987 35.678,35.678c-0,19.692 -15.987,35.678 -35.678,35.678c-19.692,0 -35.678,-15.986 -35.678,-35.678c-0,-19.691 15.986,-35.678 35.678,-35.678Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,3.62915,27831.4,-5169.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M531.461,1715.31c0,-0 0,-11.693 0,-18.094c0,-2.329 1.357,-4.444 3.474,-5.415c2.787,-1.278 6.129,-2.81 6.129,-2.81c0.197,-0.091 0.283,-0.324 0.193,-0.521c-0.09,-0.197 -0.324,-0.284 -0.521,-0.193c0,-0 -3.342,1.532 -6.129,2.81c-2.396,1.099 -3.931,3.493 -3.932,6.129c0,-0 0,18.094 0,18.094c0,0.217 0.176,0.393 0.393,0.393c0.217,-0 0.393,-0.176 0.393,-0.393Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.06806,0,0,3.04378,28313.7,-4069.56)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 673.532,
    y: 1818.11,
    width: 97.403,
    height: 60.795,
    style: {
      fill: "rgb(225,163,14)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.06806,0,0,3.04378,28313.7,-4069.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M771.4,1818.11c-0,-0.258 -0.208,-0.468 -0.465,-0.468l-97.403,-0c-0.256,-0 -0.464,0.21 -0.464,0.468l-0,60.795c-0,0.259 0.208,0.469 0.464,0.469l97.403,-0c0.257,-0 0.465,-0.21 0.465,-0.469l-0,-60.795Zm-0.929,0.469l-0,59.858c-0,0 -96.474,0 -96.474,0c0,0 0,-59.858 0,-59.858l96.474,-0Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.12279,7.33035e-14,0,2.15102,28336.5,-2474.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 673.312,
    y: 1850.07,
    width: 18.917,
    height: 28.836,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.12279,7.33035e-14,0,2.15102,28336.5,-2474.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M692.686,1850.07c-0,-0.366 -0.205,-0.662 -0.457,-0.662l-18.917,-0c-0.252,-0 -0.456,0.296 -0.456,0.662l-0,28.836c-0,0.366 0.204,0.663 0.456,0.663l18.917,0c0.252,0 0.457,-0.297 0.457,-0.663l-0,-28.836Zm-0.913,0.663l-0,27.511c-0,-0 -18.004,-0 -18.004,-0c-0,-0 -0,-27.511 -0,-27.511l18.004,0Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.12279,7.33035e-14,0,2.15102,28447.9,-2474.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 673.312,
    y: 1850.07,
    width: 18.917,
    height: 28.836,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.12279,7.33035e-14,0,2.15102,28447.9,-2474.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M692.686,1850.07c-0,-0.366 -0.205,-0.662 -0.457,-0.662l-18.917,-0c-0.252,-0 -0.456,0.296 -0.456,0.662l-0,28.836c-0,0.366 0.204,0.663 0.456,0.663l18.917,0c0.252,0 0.457,-0.297 0.457,-0.663l-0,-28.836Zm-0.913,0.663l-0,27.511c-0,-0 -18.004,-0 -18.004,-0c-0,-0 -0,-27.511 -0,-27.511l18.004,0Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,2.99973,27853.9,-4011.89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M712.361,1849.99l16.278,0c0.217,0 0.393,-0.213 0.393,-0.475c-0,-0.262 -0.176,-0.475 -0.393,-0.475l-16.278,-0c-0.216,-0 -0.392,0.213 -0.392,0.475c-0,0.262 0.176,0.475 0.392,0.475Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,2.99973,27965.2,-4011.89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M712.361,1849.99l16.278,0c0.217,0 0.393,-0.213 0.393,-0.475c-0,-0.262 -0.176,-0.475 -0.393,-0.475l-16.278,-0c-0.216,-0 -0.392,0.213 -0.392,0.475c-0,0.262 0.176,0.475 0.392,0.475Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,2.99973,27853.9,-4011.89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M720.107,1839.17l0,20.678c0,0.262 0.176,0.475 0.393,0.475c0.217,0 0.393,-0.213 0.393,-0.475l-0,-20.678c-0,-0.262 -0.176,-0.475 -0.393,-0.475c-0.217,0 -0.393,0.213 -0.393,0.475Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.62915,0,0,2.99973,27965.2,-4011.89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M720.107,1839.17l0,20.678c0,0.262 0.176,0.475 0.393,0.475c0.217,0 0.393,-0.213 0.393,-0.475l-0,-20.678c-0,-0.262 -0.176,-0.475 -0.393,-0.475c-0.217,0 -0.393,0.213 -0.393,0.475Z",
    style: {
      fill: "rgb(73,51,35)"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteSq);
export default __webpack_public_path__ + "static/media/quote_sq.cf3ad8aa8f3397419e411399c6297f7e.svg";
export { ForwardRef as ReactComponent };